export default "/static/assets/chart.bea95eb6ea0e1f13de79b7563430fe47.svg";